<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:" v-if="isShow">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否显示全部留存:">
          <el-switch
            v-model="searchValue.all_retention"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item> -->

        <commonMode
          ref="commonMode"
          @getList="(val) => {
            searchValue = {
              ...searchValue,
              ...val,
            }
            getRetentionList(true)
          }"
          :searchValue="{
            channel_id: searchValue.channel_id
          }" />
        <el-form-item>
          <el-button size="small" type="warning" @click="$refs.commonMode.dialogTableVisible = true">选择渠道策略组</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="$refs.commonMode.dialogCreateModeVisible = true">保存渠道策略组</el-button>
        </el-form-item>
        <br />
        <el-form-item label="是否分渠道:">
          <el-select
            v-model="searchValue.rechannel"
            filterable
            clearable
            placeholder="请选择"
            @change="rechannelChange"
          >
            <el-option
              v-for="item in listRechannel"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRetentionList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportUserRetention()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="daydate" label="日期" width="100" fixed> </el-table-column>
      <el-table-column prop="game.name" label="游戏名"> </el-table-column>
      <el-table-column prop="channels.name" label="渠道名"> </el-table-column>
      <el-table-column prop="newUsers" label="当日新增付费用户">
      </el-table-column>
      <el-table-column label="次日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == oneDay" style="color: red"
            >{{ scope.row.oneDay }}%</span
          >
          <span v-else-if="scope.row.daydate < oneDay" style="color: #000"
            >{{ scope.row.oneDay }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="三日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == threeDay" style="color: red"
            >{{ scope.row.threeDay }}%</span
          >
          <span v-else-if="scope.row.daydate < threeDay" style="color: #000"
            >{{ scope.row.threeDay }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="五日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == fiveDay" style="color: red"
            >{{ scope.row.fiveDay }}%</span
          >
          <span v-else-if="scope.row.daydate < fiveDay" style="color: #000"
            >{{ scope.row.fiveDay }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="7日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == oneWeek" style="color: red"
            >{{ scope.row.oneWeek }}%</span
          >
          <span v-else-if="scope.row.daydate < oneWeek" style="color: #000"
            >{{ scope.row.oneWeek }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="10日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == checkDateTime(10)" style="color: red"
            >{{ scope.row.retention_10 }}%</span
          >
          <span v-else-if="scope.row.daydate < checkDateTime(10)" style="color: #000"
            >{{ scope.row.retention_10 }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="12日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == checkDateTime(12)" style="color: red"
            >{{ scope.row.retention_12 }}%</span
          >
          <span v-else-if="scope.row.daydate < checkDateTime(12)" style="color: #000"
            >{{ scope.row.retention_12 }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="15日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == halfMonth" style="color: red"
            >{{ scope.row.halfMonth }}%</span
          >
          <span v-else-if="scope.row.daydate < halfMonth" style="color: #000"
            >{{ scope.row.halfMonth }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="18日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == checkDateTime(18)" style="color: red"
            >{{ scope.row.retention_18 }}%</span
          >
          <span v-else-if="scope.row.daydate < checkDateTime(18)" style="color: #000"
            >{{ scope.row.retention_18 }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="21日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == checkDateTime(21)" style="color: red"
            >{{ scope.row.retention_21 }}%</span
          >
          <span v-else-if="scope.row.daydate < checkDateTime(21)" style="color: #000"
            >{{ scope.row.retention_21 }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="24日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == checkDateTime(24)" style="color: red"
            >{{ scope.row.retention_24 }}%</span
          >
          <span v-else-if="scope.row.daydate < checkDateTime(24)" style="color: #000"
            >{{ scope.row.retention_24 }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="30日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == oneMonth" style="color: red"
            >{{ scope.row.oneMonth }}%</span
          >
          <span v-else-if="scope.row.daydate < oneMonth" style="color: #000"
            >{{ scope.row.oneMonth }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="60日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == twoMonth" style="color: red"
            >{{ scope.row.twoMonth }}%</span
          >
          <span v-else-if="scope.row.daydate < twoMonth" style="color: #000"
            >{{ scope.row.twoMonth }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="90日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == quarter" style="color: red"
            >{{ scope.row.quarter }}%</span
          >
          <span v-else-if="scope.row.daydate < quarter" style="color: #000"
            >{{ scope.row.quarter }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="120日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == third" style="color: red"
            >{{ scope.row.third }}%</span
          >
          <span v-else-if="scope.row.daydate < third" style="color: #000"
            >{{ scope.row.third }}%</span
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="150日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == three_quarters" style="color: red">{{
            scope.row.three_quarters
          }}%</span>
          <span v-else-if="scope.row.daydate < three_quarters" style="color: #000">{{
            scope.row.three_quarters
          }}%</span>
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="180日付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == half_year" style="color: red">{{
            scope.row.half_year
          }}%</span>
          <span v-else-if="scope.row.daydate < half_year" style="color: #000">{{
            scope.row.half_year
          }}%</span>
          <span v-else>/</span>
        </template>
      </el-table-column>
      <el-table-column label="一年付费留存率">
        <template slot-scope="scope">
          <span v-if="scope.row.daydate == year" style="color: red">{{
            scope.row.year
          }}%</span>
          <span v-else-if="scope.row.daydate < year" style="color: #000">{{
            scope.row.year
          }}%</span>
          <span v-else>/</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
import commonMode from '@/component/commonMode.vue'

export default {
  name: "userRetention",
  components: {
    commonMode
  },
  data() {
    return {
      loadingData: false,
      value1: [],
      searchValue: {
        game_id: "",
        channel_id: [],
        created_from: "",
        created_to: "",
        rechannel: "",
        group_channel_ids: "",
        all_retention: 0,
      },
      listRechannel: [
        {
          id: 0,
          name: "分渠道",
        },
        {
          id: 1,
          name: "不分渠道",
        },
      ],
      isShow: true,
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      collect: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      oneDay: "",
      threeDay: "",
      fiveDay: "",
      oneWeek: "",
      halfMonth: "",
      oneMonth: "",
      twoMonth: "",
      quarter: "",
      third: "",
      three_quarters: "",
      half_year: "",
      year: "",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.addDate();
    let date = moment().startOf("month"); //当月第一天
    let y = date.get("year");
    let m = date.get("month") + 1;
    let d = date.get("date");
    let dateStart = y + "-" + m + "-" + d + " " + "00:00:00";

    this.value1[0] = dateStart;
    this.value1[1] = this.systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];

    // 是否分渠道 默认选中项
    this.searchValue.rechannel = this.listRechannel[0].id;

    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.getRetentionList(true);
    this.dateTimeChange();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRetentionList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRetentionList(false);
    },
    checkDateTime (date) {
      return moment().subtract(date - 1, "days").format("YYYY-MM-DD")
    },
    dateTimeChange() {
      this.oneDay = moment().subtract(1, "days").format("YYYY-MM-DD");
      this.threeDay = moment().subtract(2, "days").format("YYYY-MM-DD");
      this.fiveDay = moment().subtract(4, "days").format("YYYY-MM-DD");
      this.oneWeek = moment().subtract(6, "days").format("YYYY-MM-DD");
      this.halfMonth = moment().subtract(14, "days").format("YYYY-MM-DD");
      this.oneMonth = moment().subtract(29, "days").format("YYYY-MM-DD");
      this.twoMonth = moment().subtract(59, "days").format("YYYY-MM-DD");
      this.quarter = moment().subtract(89, "days").format("YYYY-MM-DD");
      this.third = moment().subtract(119, "days").format("YYYY-MM-DD");
      this.three_quarters = moment().subtract(149, "days").format("YYYY-MM-DD");
      this.half_year = moment().subtract(179, "days").format("YYYY-MM-DD");
      this.year = moment().subtract(364, "days").format("YYYY-MM-DD");
    },
    addDate() {
      let date1 = moment().endOf("month"); //当月最后一天
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;
      let dd = date1.get("date");
      this.systemTime = yy + "-" + mm + "-" + dd + " " + "23:59:59";
    },

    // 导出
    exportUserRetention() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/statistics/pay_retention", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },
    // 通过选择是否分渠道 控制所属渠道是否显示或隐藏
    rechannelChange(selectValue) {
      if (selectValue == 1) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 实现渠道包数据的搜索
    searchRetentionList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1].replace(
        "00:00:00",
        "23:59:59"
      ) : '';
      this.currentPage = 1;
      this.getRetentionList(true);
    },
    // 展示用户角色列表数据
    getRetentionList(reload = false) {
      let searchValue = {};

      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      fetch({
        url: "/admin/statistics/pay_retention",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data[0].data;
            this.collect = res.data.data.collect;
            this.totalRecords = res.data.data[0].total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 数据统计
    getSummaries(param) {
      let arr = ["合计", "", "", this.collect['newUsers']];
      ['oneDay', 'threeDay', 'fiveDay', 'oneWeek', 'retention_10', 'retention_12',
        'halfMonth', 'retention_18', 'retention_21', 'retention_24', 'oneMonth', 'twoMonth',
        'quarter', 'third', 'three_quarters', 'half_year', 'year'
      ].forEach(prop => {
        arr.push(this.collect[prop] + "%")
      })
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
